export class ProfileSensoryProfileQuestion {

  _id: string;
  answerValue: number;
  question: {
    _id: string;
    index: number;
    statement: string;
    umbralKey: number;
  }


  constructor(obj) {
    obj && Object.assign(this, obj);
  }
}
